// P08
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import React, { useContext, useReducer } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import DeviationFlagBase from './DeviationFlagBase';
import DailyDeviationCard from './DailyDeviationCard';
import DeviationFlagCard from './_partials/DeviationFlagCard';
import PositionOnlyPopperPopover from '@wix/da-ds/pkg/popper/presets/PositionOnlyPopperPopover';
import s from './DeviationFlags.scss';
const createFlagStateReducer = (isMobile)=>(state, action)=>{
        switch(action){
            case 'mouseEnter':
                return isMobile ? state : {
                    isFlagListVisible: true,
                    isHovering: true
                };
            case 'mouseLeave':
                return isMobile ? state : _object_spread_props(_object_spread({}, state), {
                    isHovering: false
                });
            case 'click':
                return isMobile ? state.isFlagListVisible ? _object_spread_props(_object_spread({}, state), {
                    isHovering: false
                }) : {
                    isFlagListVisible: true,
                    isHovering: true
                } : state;
            case 'transitionEnd':
                return state.isHovering ? state : _object_spread_props(_object_spread({}, state), {
                    isFlagListVisible: false
                });
            default:
                return state;
        }
    };
const DeviationFlags = ({ deviation, deviation: { dailyDeviation }, alwaysExpanded, disableLabel, className })=>{
    const dd_and_hype_banners = useFlag('dd_and_hype_banners');
    const { t } = useTranslation();
    const isMobile = useContext(MobileContext);
    const [{ isFlagListVisible, isHovering }, dispatch] = useReducer(createFlagStateReducer(isMobile), {
        isFlagListVisible: false,
        isHovering: false
    });
    if (!dailyDeviation) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], alwaysExpanded && s['always-expanded'], isHovering && s['hovering'], isFlagListVisible && s['visible'], disableLabel && s['disable-label'], className),
        onClick: ()=>dispatch('click'),
        onMouseEnter: ()=>dispatch('mouseEnter'),
        onMouseLeave: ()=>dispatch('mouseLeave'),
        onTransitionEnd: (e)=>{
            if (e.propertyName === 'opacity') {
                dispatch('transitionEnd');
            }
        }
    }, /*#__PURE__*/ React.createElement(PositionOnlyPopperPopover, {
        placement: "top",
        secondaryPlacement: isMobile ? 'end' : 'start',
        wrapperClassName: s['tooltip'],
        usePortal: false,
        eventsEnabled: isHovering,
        popoverContent: ({ placement })=>/*#__PURE__*/ React.createElement("div", {
                className: classnames(s['flag-list'], s[placement], isFlagListVisible && s['flag-list-visible'])
            }, dd_and_hype_banners ? /*#__PURE__*/ React.createElement(DeviationFlagCard, {
                variant: "daily-deviation",
                deviation: deviation
            }) : /*#__PURE__*/ React.createElement(DailyDeviationCard, {
                dailyDeviation: dailyDeviation
            }))
    }, /*#__PURE__*/ React.createElement(DeviationFlagBase, {
        title: t(`actionbar.flags.dailyDeviation`)
    })));
};
DeviationFlags.displayName = 'DeviationFlags';
export default DeviationFlags;
